import { useAuthStore } from '@/features/auth/store/authStore';

// Returns true when the current user's email is verified. Reads from the
// JWT-derived authStore flag; flips immediately after a successful
// verify-email call in the same tab (markEmailVerified is called there).
export function useEmailVerified(): boolean {
  return useAuthStore((s) => s.user?.isEmailVerified ?? false);
}
